import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mb-3 container row justify-content-md-center"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-3 row justify-content-md-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.reRender)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.returnIfExists(_ctx.statTypeEnum.ElementType) === 'button')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                "data-bs-toggle": "tooltip",
                "data-bs-placement": "top",
                class: _normalizeClass(_ctx.object.Stats[_ctx.statTypeEnum.Design].Data),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.regionType.RegionTypes[_ctx.object.Region].ObjectTypes[_ctx.objectTypeEnum.Button].ChooseSubType(JSON.parse(JSON.stringify(_ctx.objectCopy(_ctx.object as ObjectTemplate))) as ObjectTemplate)), ["prevent"]))
              }, _toDisplayString(_ctx.object.Stats[_ctx.statTypeEnum.Label].Data), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedObjectTemplates, (group, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-group",
                    key: `${ index }-${ Math.random().toString(36).slice(2, 7) }`
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (_objectTemplate, key) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(_objectTemplate.Region, _objectTemplate.ObjectEnum)), {
                        object: _objectTemplate,
                        key: `${ key }-${ Math.random().toString(36).slice(2, 7) }`
                      }, null, 8, ["object"]))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _hoisted_6
            ]))
      ]))
    : _createCommentVNode("", true)
}